var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.downloadFlag
      ? _c(
          "div",
          { staticClass: "mb5 mr" },
          [
            _c(
              "el-button",
              {
                staticClass: "swb-btn swb-btn-primary",
                on: {
                  click: function($event) {
                    _vm.download()
                  }
                }
              },
              [_vm._v("下载")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.typeId == 302
      ? _c(
          "div",
          [
            _c(
              "el-table",
              {
                ref: "deviceImpInfoTable",
                attrs: { data: _vm.servicerServcProcessProduct, border: "" }
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "shopName", label: "门店", align: "left" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "period",
                    label: "时段",
                    width: "150",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "shoudScanQuantity",
                    label: "应扫数量",
                    width: "100",
                    align: "right"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(rows.row.shoudScanQuantity || 0))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "actualScanQuantity",
                    label: "实扫数量",
                    width: "100",
                    align: "right"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(rows.row.actualScanQuantity || 0))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "notScanQuantity",
                    label: "未扫数量",
                    width: "100",
                    align: "right"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(rows.row.notScanQuantity || 0))
                          ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "el-table",
              {
                ref: "deviceImpInfoTable",
                attrs: { data: _vm.servicerServcProcessProduct, border: "" }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "groupName",
                    label: "分组名称",
                    align: "left",
                    width: "100"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "servicerName",
                    label: "服务商",
                    align: "left"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "repairQuantity",
                    label: _vm.typeId == 301 ? "保养数量" : "报修数量",
                    width: "100",
                    align: "right"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(rows.row.repairQuantity || 0))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "readyStartQuantity",
                    label: "未出发数量",
                    width: "100",
                    align: "right"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(rows.row.readyStartQuantity || 0))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "readyArrivedQuantity",
                    label: "未到达数量",
                    width: "100",
                    align: "right"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(rows.row.readyArrivedQuantity || 0))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "inServiceQuantity",
                    label: "服务中数量",
                    width: "100",
                    align: "right"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(rows.row.inServiceQuantity || 0))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "failed",
                    label: "服务暂停数量",
                    width: "100",
                    align: "right"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(rows.row.serveInterruptQuantity || 0))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "failed",
                    label: "未验收数量",
                    width: "100",
                    align: "right"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(rows.row.completedQuantity || 0))
                          ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00340986", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00340986","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/easyReport/MerchtReportSnapshotView.vue
// module id = 4072
// module chunks = 0